export enum GamPlacementDataStatus {
  GamCreativeIdMissing = 'gam_creative_id_missing',
  GamCampaignIdMissing = 'gam_campaign_id_missing',
  GamLineItemIdMissing = 'gam_line_item_id_missing',
  GamAdvertiserIdMissing = 'gam_advertiser_id_missing',
  GamRenderNonEmpty = 'gam_render_non_empty',
  GamSourceAgnosticLineItemIdMissing = 'gam_source_agnostic_line_item_id_missing',
  GamSourceAgnosticCreativeIdMissing = 'gam_source_agnostic_creative_id_missing'
}
